import { Stack, Typography, useTheme } from '@mui/material';
import { PAYMENT_PRICING } from '@/app/utilities/consts';
import Label from '../label';
import { useAppSettingsContext } from '../contexts/app-settings-context';
import StripePaymentModal from './stripe-payment-modal';
import { PayNowButton } from './pay-now-button';
import PayPalPaymentModal from './paypal-payment-modal';

export const PaymentPricing = ({ device, playlists }) => {
  const { settings } = useAppSettingsContext();

  const paymentSetting = Array.isArray(settings)
    ? settings.find(item => item.key === 'payment-setting')
    : undefined;

  const theme = useTheme();
  return (
    <Stack
      gap={4}
      sx={{
        flexDirection: {
          xs: 'column',
          sm: 'row',
        },
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      {PAYMENT_PRICING.map(
        (price, index) =>
          price.enabled && (
            <Stack
              key={index}
              gap={1}
              sx={{
                minWidth: '160px',
                maxWidth: '400px',
                width: '100%',
                bgcolor: theme.palette.background.neutral,
                alignItems: 'center',
                paddingTop: 3,
                paddingBottom: 2,
                boxShadow: theme.customShadows.z12,
                borderRadius: theme.shape.borderRadius * 0.15,
                position: 'relative',
              }}
            >
              <Typography variant="h4">{price.title}</Typography>
              {price.discount ? (
                <Stack flexDirection="row" gap={1}>
                  <Typography
                    variant="h6"
                    sx={{
                      color: theme.palette.text.secondary,
                      textDecoration: 'line-through',
                      fontWeight: 'normal',
                    }}
                  >
                    {`$${price.price} USD`}
                  </Typography>
                  <Typography
                    variant="h5"
                    sx={{ color: theme.palette.primary.main, fontWeight: 'normal' }}
                  >
                    {`$${price.discount} USD`}
                  </Typography>
                </Stack>
              ) : (
                <Typography
                  variant="h5"
                  sx={{ color: theme.palette.primary.main, fontWeight: 'normal' }}
                >
                  {`$${price.price} USD`}
                </Typography>
              )}

              {price.percent && (
                <Label
                  variant="soft"
                  color="success"
                  sx={{ position: 'absolute', right: 20, top: 20 }}
                >
                  {`${price.percent} OFF`}
                </Label>
              )}

              <Stack
                gap={1}
                sx={{
                  width: '100%',
                  px: {
                    xs: 2,
                    sm: 2,
                    md: 4,
                  },
                  pt: 2,
                  pb: 1,
                  alignItems: 'center',
                }}
              >
                {paymentSetting?.value?.stripe && (
                  <StripePaymentModal
                    device={device}
                    tier={price}
                    pKey={paymentSetting?.value?.stripe_public_key}
                    pCount={playlists?.length}
                  />
                )}
                {paymentSetting?.value?.paypal && (
                  <PayPalPaymentModal device={device} tier={price} pCount={playlists?.length} />
                )}
              </Stack>
            </Stack>
          )
      )}
      <PayNowButton />
    </Stack>
  );
};
